/**
 * Prototype UI — replace with Medplum hooks later.
 */

export type DenialStatus = 'open' | 'appealing' | 'corrected' | 'closed';

export interface DenialRow {
  id: string;
  claimId: string;
  eobId: string;
  clientName: string;
  payer: string;
  denialReason: string;
  carc: string;
  rarc: string;
  owner: string;
  dueDate: string;
  status: DenialStatus;
}

export const MOCK_DENIALS: DenialRow[] = [];

export function findDenialById(id: string | undefined): DenialRow | undefined {
  if (!id) return undefined;
  return MOCK_DENIALS.find((r) => r.id === id);
}
